document.addEventListener("DOMContentLoaded", function () {
  const handle = document.getElementById("vault-handle");
  const errorMsg = document.getElementById("vault-error");

  if (!handle) {
    console.warn("[VAULT] #vault-handle not found");
    return;
  }

  // Click event
  handle.addEventListener("click", function () {
    // Hide error message
    if (errorMsg) {
      errorMsg.style.display = "none";
    }

    // Add spin animation
    handle.classList.add("spinning");

    // Optional: After spin ends, show "unlocked" or redirect
    setTimeout(() => {
      // Example: show unlocked message
      alert("✅ ACCESS GRANTED!"); 
      // Or redirect to a collection:
      // window.location.href = "/collections/vault";
    }, 2000);
  });
});
// === Countdown to Friday 5PM Arizona (MST) ===
function getNextFriday5pm() {
  const now = new Date();
  const options = { timeZone: "America/Phoenix" };
  let friday = new Date(
    new Date().toLocaleString("en-US", options) // convert to AZ time
  );

  // set to Friday
  friday.setDate(friday.getDate() + ((5 - friday.getDay() + 7) % 7));
  friday.setHours(17, 0, 0, 0); // 5:00 PM

  // if it's already past Friday 5PM today, go to next week
  if (friday < now) {
    friday.setDate(friday.getDate() + 7);
  }

  return friday;
}

function startCountdown() {
  const target = getNextFriday5pm();

  function update() {
    const now = new Date();
    const diff = target - now;

    if (diff <= 0) {
      document.getElementById("timer-countdown").innerText = "00:00:00:00";
      clearInterval(interval);
      return;
    }

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((diff / (1000 * 60)) % 60);
    const seconds = Math.floor((diff / 1000) % 60);

    document.getElementById("timer-countdown").innerText =
      `${days}d ${hours}h ${minutes}m ${seconds}s`;
  }

  update(); // run immediately
  const interval = setInterval(update, 1000);
}
// ===== Countdown to Friday 5:00 PM (America/Phoenix) with HUD UI =====
(function(){
  const root = document.getElementById('vault-timer');
  if (!root) return;

  const TZ = 'America/Phoenix';
  const pad = n => String(n).padStart(2,'0');

  const phoenixNow = () =>
    new Date(new Date().toLocaleString('en-US', { timeZone: TZ }));

  function nextFridayAt5pmPhoenix() {
    const now = phoenixNow();
    const t = new Date(now);
    const daysUntilFri = (5 - now.getDay() + 7) % 7; // Fri=5
    t.setDate(now.getDate() + daysUntilFri);
    t.setHours(17, 0, 0, 0); // 5:00 PM
    if (t <= now) t.setDate(t.getDate() + 7); // if already past 5pm today, roll a week
    return t;
  }

  function parts(ms){
    if (ms <= 0) return { d:0, h:0, m:0, s:0 };
    return {
      d: Math.floor(ms / 86400000),
      h: Math.floor((ms % 86400000) / 3600000),
      m: Math.floor((ms % 3600000) / 60000),
      s: Math.floor((ms % 60000) / 1000)
    };
  }

  function render(p){
    root.innerHTML = `
      <div class="vt" aria-label="Countdown to Friday 5PM (Arizona)">
        <div class="unit"><span class="num">${pad(p.d)}</span><span class="lab">DAYS</span></div>
        <div class="unit"><span class="num">${pad(p.h)}</span><span class="lab">HOURS</span></div>
        <div class="unit"><span class="num">${pad(p.m)}</span><span class="lab">MINS</span></div>
        <div class="unit"><span class="num">${pad(p.s)}</span><span class="lab">SECS</span></div>
      </div>`;
  }

  let target = nextFridayAt5pmPhoenix();

  function tick(){
    const ms = target - phoenixNow();
    if (ms <= 0) target = nextFridayAt5pmPhoenix(); // auto-reset weekly
    render(parts(ms));
  }

  tick();
  setInterval(tick, 1000);
})();
// ===== Countdown to Friday 5:00 PM (America/Phoenix) with HUD UI =====
(function(){
  const root = document.getElementById('vault-timer');
  if (!root) return;

  const TZ = 'America/Phoenix';
  const pad = n => String(n).padStart(2,'0');

  const phoenixNow = () =>
    new Date(new Date().toLocaleString('en-US', { timeZone: TZ }));

  function nextFridayAt5pmPhoenix() {
    const now = phoenixNow();
    const t = new Date(now);
    const daysUntilFri = (5 - now.getDay() + 7) % 7; // Fri=5
    t.setDate(now.getDate() + daysUntilFri);
    t.setHours(17, 0, 0, 0); // 5:00 PM
    if (t <= now) t.setDate(t.getDate() + 7); // if already past 5pm today, roll a week
    return t;
  }

  function parts(ms){
    if (ms <= 0) return { d:0, h:0, m:0, s:0 };
    return {
      d: Math.floor(ms / 86400000),
      h: Math.floor((ms % 86400000) / 3600000),
      m: Math.floor((ms % 3600000) / 60000),
      s: Math.floor((ms % 60000) / 1000)
    };
  }

  function render(p){
    root.innerHTML = `
      <div class="vt" aria-label="Countdown to Friday 5PM (Arizona)">
        <div class="unit"><span class="num">${pad(p.d)}</span><span class="lab">DAYS</span></div>
        <div class="unit"><span class="num">${pad(p.h)}</span><span class="lab">HOURS</span></div>
        <div class="unit"><span class="num">${pad(p.m)}</span><span class="lab">MINS</span></div>
        <div class="unit"><span class="num">${pad(p.s)}</span><span class="lab">SECS</span></div>
      </div>`;
  }

  let target = nextFridayAt5pmPhoenix();

  function tick(){
    const ms = target - phoenixNow();
    if (ms <= 0) target = nextFridayAt5pmPhoenix(); // auto-reset weekly
    render(parts(ms));
  }

  tick();
  setInterval(tick, 1000);
})();
